import { Button } from "@/components/ui/button";
import moment from "moment";
import { useApiList } from "@/queries";

export function RrtReportingDetailHandler({ currentExport, data, dataSave, exportToExcel }) {
  const { data: users } = useApiList(currentExport == "rrt reporting" ? "/v2/user" : null, [currentExport]);
  const userByKey = new Map();
  users?.forEach((u) => {
    if (u.alias) userByKey.set(String(u.alias), u);
    if (u.id) userByKey.set(String(u.id), u);
    if (u.name) userByKey.set(String(u.name), u);
    if (u.logistic_staff?.alias) userByKey.set(String(u.logistic_staff.alias), u);
    if (u.logistic_staff?.code) userByKey.set(String(u.logistic_staff.code), u);
    if (u.repair_center?.alias) userByKey.set(String(u.repair_center.alias), u);
    if (u.repair_center?.code) userByKey.set(String(u.repair_center.code), u);
    if (u.repair_center_engineer?.alias) userByKey.set(String(u.repair_center_engineer.alias), u);
    if (u.repair_center_engineer?.code) userByKey.set(String(u.repair_center_engineer.code), u);
    if (u.service_engineer?.alias) userByKey.set(String(u.service_engineer.alias), u);
    if (u.service_engineer?.code) userByKey.set(String(u.service_engineer.code), u);
  });
  const resolveRepairCode = (val) => {
    if (!val) return "-";
    const hit = userByKey.get(String(val));
    if (hit) return hit.repair_center?.code || hit.repair_center_engineer?.code || hit.repair_center?.alias || hit.repair_center_engineer?.alias || hit.alias || String(val);
    return String(val);
  };
  const resolveServiceCode = (val) => {
    if (!val) return "-";
    const hit = userByKey.get(String(val));
    if (hit) return hit.service_engineer?.code || hit.service_engineer?.alias || hit.alias || String(val);
    return String(val);
  };

  if (currentExport == "rrt reporting") {
    const exportData = dataSave.repair_request_tickets
      .filter((obj) => {
        if (data.date_from && data.date_to) {
          return moment(obj.created_at).isBetween(data.date_from, data.date_to);
        } else {
          return true;
        }
      })
      .filter((obj) => {
        if (data.part_platform_id) {
          return obj.part_repairs.part_repairables?.part_details?.part_platform_id == data.part_platform_id;
        } else {
          return true;
        }
      })
      .map((obj, idx) => {
        const findWork = (codes) => obj.rrt_status_works.find((sw) => codes.includes(sw.status_work_code));
        const openTime = findWork(["ONR", "RRO"])?.created_at;
        const stopTime = obj.rrt_status_works.find((sw) => sw.status_work_code === "RRF")?.created_at;
        const returnTime = obj.rrt_status_works.find((sw) => sw.status_work_code === "RPT")?.created_at;

        const partDetails = obj.part_repairs?.part_repairables?.part_details;
        const partSn = obj.part_repairs?.part_repairables?.part_sn || obj.part_repairs?.part_sn || "-";

        // Repair engineer: try rrt_details.repair_center_engineer.code, fallback to RRF/RRA updated_by resolved to code
        const repairEngineerRaw =
          obj.rrt_details?.repair_center_engineer?.code ||
          obj.rrt_details?.repair_center_engineer?.alias ||
          findWork(["RRF", "RRP", "RRA"])?.updated_by ||
          "-";
        const repairEngineer = repairEngineerRaw === "-" ? "-" : resolveRepairCode(repairEngineerRaw);

        // Service engineer: try rrt_details.service_order_ticket.on_duty_service_engineer.code or via part_requests chain
        const serviceEngineerRaw =
          obj.rrt_details?.service_order_ticket?.on_duty_service_engineer?.code ||
          obj.rrt_details?.service_order_ticket?.on_duty_service_engineer?.alias ||
          obj.part_repairs?.part_repairables?.part_requests?.part_request_tickets?.service_order_ticket?.on_duty_service_engineer?.code ||
          "-";
        const serviceEngineer = serviceEngineerRaw === "-" ? "-" : resolveServiceCode(serviceEngineerRaw);

        const partUsages = obj.repair_part_usages || obj.part_usages || [];
        const partUsageStr =
          Array.isArray(partUsages) && partUsages.length > 0
            ? partUsages
                .map((pu) => {
                  const pn = pu.part_detail?.part_number || pu.part_details?.part_number || pu.part_number || "-";
                  const nm = pu.part_detail?.name || pu.part_details?.name || pu.name || "-";
                  const qty = pu.part_quantity ?? pu.quantity ?? 1;
                  return `${pn} - ${nm} - ${qty}`;
                })
                .join(", ")
            : "-";

        return {
          No: idx + 1,
          "RRT No": obj.rr_ticket_no,
          Partnumber: partDetails?.part_number || "-",
          "Part description": partDetails?.name || partDetails?.description || "-",
          "Serial Number": partSn || "-",
          "RRT Note": obj.notes || obj.last_status_work_notes || "-",
          "Open Time": openTime ? moment(openTime).subtract(7, "hours").format("YYYY-MM-DD HH:mm:ss") : "-",
          "Stop Repair Time": stopTime ? moment(stopTime).subtract(7, "hours").format("YYYY-MM-DD HH:mm:ss") : "-",
          "Returned Time": returnTime ? moment(returnTime).subtract(7, "hours").format("YYYY-MM-DD HH:mm:ss") : "-",
          "list of part usage": partUsageStr,
          "Repair enginer": repairEngineer,
          "Service enginer": serviceEngineer,
        };
      });

    return (
      <Button
        variant="primary"
        onClick={() => exportToExcel(exportData, `rrt_detail_${moment().format("hhmm_DDMMYYYY")}.xlsx`)}
      >
        Submit
      </Button>
    );
  }
  return null;
}
